
import { Options, Vue } from 'vue-class-component';
import ModalBox from '@/shared/components/modal-box/index.vue';
import { Inject, Prop, Watch } from 'vue-property-decorator';
import { TrustAPI } from '@/shared/modules/trust-api';
import LoadingIndicator from '@/shared/components/loading-indicator/index.vue';
import { EventEmitter } from 'events';
import ErrorIndicator from '@/shared/components/error-indicator/index.vue';
import { orderBy } from 'lodash';
import store from '@/trust-atcs-app/store';
import { ComplianceForm, IndividualPracticeRequest, PracticeAtcs } from '@/shared/modules/typescript-trustapi-client/models';

@Options({
  components: {
    ModalBox,
    LoadingIndicator,
    ErrorIndicator,
  }
})
export default class AssignTrustContact extends Vue {

  @Inject({ from: 'apiService', default: new TrustAPI() })
  private apiService!: TrustAPI;

  @Prop({ default: null })
  private practice!: ComplianceForm;

  private trustContact = null;
  private errorWithContact = false;

  get eventCtrl(): EventEmitter {
    return store.getters.getEventController;
  }

  private loadingEvents = false;

  private submitting = false;

  private closeModal(): void {
    this.eventCtrl.emit('loadCardData');
    this.$emit('close');
  }

  
  private async assignContact(): Promise<void> {
    try {
      this.submitting = true;
      await this.apiService.PracticeAtcsApi?.apiV2AtcsPracticeSaveTrustContactPost({
        practiceCoreId: this.practice?.practice?.practiceCoreId,
        searchText: this.trustContact,
      });
      this.eventCtrl.emit('show-snackbar', 'success', 'Assigned Trust Contact successfully');
      this.closeModal();
    } catch {
      this.eventCtrl.emit('show-snackbar', 'error', 'Problem assigning Trust Contact');
      this.errorWithContact = true;
    } finally {
      this.submitting = false;
    }
  }

  get validForm(): boolean {
    return !!this.trustContact;
  }

  get isFormDirty(): boolean {
    return true;
  }

}

